import api from './api'

export const getTimezones = () => api.get('/location/timezones/')
